import { ButtonPrimary } from '../../../../utils/Button';

function TextPreview(rawText = '') {
    const splitText = rawText?.split('\n');
    return (
        <>
            {splitText.map((text, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <p key={index}>{text}</p>
            ))}
        </>
    );
}
function InfoCard({ title, value }) {
    return (
        <div className="flex justify-between items-center w-full p-2 md:p-3 rounded-10 bg-primary-50 overflow-hidden box-border">
            <div className="w-10/12">
                <h3 className="text-primary-700 text-sm md:text-base font-normal">
                    {title || '--'}
                </h3>
                <div className="w-full text-primary text-base md:text-xl font-medium bg-transparent">
                    {value}
                </div>
            </div>
        </div>
    );
}

function InvoiceNote({ data, setOpenModal }) {
    return (
        <div className="flex gap-3 bg-primary-50 justify-between items-center rounded-md">
            <div className="flex flex-col gap-3 flex-1">
                <InfoCard
                    title={data?.noteTitle || '------'}
                    value={
                        data?.noteDescription ? (
                            <div className="text-sm">{TextPreview(data?.noteDescription)}</div>
                        ) : (
                            '------'
                        )
                    }
                />
            </div>
            <div className="flex justify-end pr-2">
                <ButtonPrimary title="Update Note" onClick={() => setOpenModal('update_note')} />
            </div>
        </div>
    );
}

export default InvoiceNote;
